import {FETCH_DAILYMASS} from './types';
import salomapi from '../apis';


export const fetchDailymass = () => async dispach => {
    const response = await salomapi.get('/program/single?url=daily-mass');
    dispach({type:FETCH_DAILYMASS,payload:response.data})
}